import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get, isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'

import { Select } from 'components/fields'
import { form } from 'helpers/decorators'
import { apiLocales } from 'helpers/decorators/api'
import { localesSupportedDD } from 'redux/selectors/locales'
import { editPersonLocale } from 'redux/modules/api/dashboard/persons'
import { onRefreshPage } from 'redux/modules/app'
import config from 'config'

import styles from './locale-switch.styl'
import { setManualLangSwitch } from '../../../utils/cookies'

const enhance = compose(
  withRouter,
  form({
    form: 'changeLocale',
    disableHook: true,
  }),
  apiLocales(),
  connect(state => ({
      hasUser: !isEmpty(state.auth.user) && state.auth.loaded,
      userId: get(state, 'auth.user.personId'),
      profile: get(state, 'api.dashboard.persons.profile.data', {}),
      localesSupportedDD: localesSupportedDD(state),
      customization: get(state, 'api.organizations.customization')
    }),
    { editPersonLocale, onRefreshPage }
  )
)

class LocaleSwitch extends Component {
  static propTypes = {
    change: PropTypes.func,
    changeLocale: PropTypes.func,
    labelless: PropTypes.bool,
    localesSupportedDD: PropTypes.array,
    initialize: PropTypes.func.isRequired,
    locales: PropTypes.object,
    router: PropTypes.object,
    locale: PropTypes.object,
    hasUser: PropTypes.bool,
    editPersonLocale: PropTypes.func,
    onRefreshPage: PropTypes.func,
    userId: PropTypes.number,
    profile: PropTypes.object,
    customization: PropTypes.object
  }

  static defaultProps = {
    localesSupportedDD: [],
    labelless: true,
    locales: {
      data: [],
    },
  }

  componentDidMount() {
    this.props.initialize({
      locale: {
        value: get(this.props.locale, 'id'),
        label: get(this.props.locale, 'name'),
      },
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.locale && nextProps.locale !== this.props.locale) {
      this.props.change('locale', get(nextProps, 'locale.id'))
    }
  }

  handleChangeLocale = async ({ value }) => {
    const { locales, locale, hasUser, profile, userId, router } = this.props

    const updateLocale = locales.data.filter(item => item.id === value)[0]

    const homePageCode = get(this.props, 'customization.homePageCode')

    try {

      this.props.changeLocale(updateLocale)
      setManualLangSwitch(true)

      const hasLocaleParam = window.location.search.includes('locale')

      if (hasLocaleParam) {

        router.push(config.publicPath + '/?locale=' + locale.code)
      }

      if (hasUser) {
        const data = { ...profile, locale: { id: value } }

        this.props.editPersonLocale(userId, data).then(() => {
          if (value !== locale.id) {
            this.props.onRefreshPage(true)
            window.location = homePageCode ? config.publicPath + "/" + homePageCode : config.publicPath
          }
        })
      } else if (value !== locale.id) {
        this.props.onRefreshPage(true)
        window.location = homePageCode ? config.publicPath + "/" + homePageCode : config.publicPath
      }
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    const { localesSupportedDD, labelless, locales } = this.props

    return (
      <div className={styles.localeSwitch}>
        <Select
          labelless={labelless}
          label="Language"
          intlKey="label.language"
          name="locale"
          options={localesSupportedDD}
          onSelectChange={this.handleChangeLocale}
          searchable
          loading={locales.loading}
          clearable={false}
        />
      </div>
    )
  }
}

export default enhance(LocaleSwitch)
